module.exports = __webpack_public_path__ + "static/img/productIntroduction_04.73dff0b9.jpg";